/*
 * Public API Surface of kraken-footer
 */

export * from './lib/kraken-footer.service';
export * from './lib/kraken-footer.component';
export * from './lib/kraken-footer.module';
